<template>
  <div class="report-view report-summary-information">
    <div class="report-head">
      <h5 class="text-center">{{ $t('Сводные сведения по численности сурков в охотугодьях') }}
        на {{ year }} года
        <label v-if="oopt"><u>{{ oopt }}</u></label>
        <label v-if="mainSoate"><u>{{ mainSoate }}</u></label>
        <label v-else-if="soate"><u>{{ soate }}</u></label>
      </h5>
    </div>
    <!-- report-body -->
    <div class="report-body">
      <div class="table-overflow">
        <table class="table-full">
          <thead>
          <tr>
            <td>№</td>
            <td>{{ $t('Наименование  области (охотхозяйств, охотучастков)') }}</td>
            <td>{{ $t('Общая площадь, тыс. га') }}</td>
            <td>{{ $t('Площадь местообитания сурка в охотхозяйстве, га') }}</td>
            <td>{{ $t('Численность') }}</td>
            <td>{{ $t('Лимит отлова численности 20%') }}</td>
          </tr>
          </thead>
          <tbody>
          <template v-if="reportData.resultData">
            <tr v-for="(item, itemName, key) in reportData.resultData" :key="item.id">
              <td class="td-num">{{ key + 1 }}</td>
              <td>{{ item.name }}</td>
              <td>
                <template v-if="typeof item.observeArea === 'object' && item.observeArea">
                  {{ item.observeArea.total }}
                </template>
                <template v-else>{{item.observeArea }}</template>
              </td>
              <td>{{ item.area }}</td>
              <td>{{ item.accountWithCC }}</td>
              <td>{{ item.limit }}</td>
            </tr>
          </template>
          <tr>
            <td colspan="2"><b>{{ $t('Итого') }}:</b></td>
            <td>{{ reportData.total['observeArea'] }}</td>
            <td>{{ reportData.total['area'] }}</td>
            <td>{{ reportData.total['accountWithCC'] }}</td>
            <td>{{ reportData.total['limit'] }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="report-footer">
      <div class="report-footer-item">
        <div class="flexbox">
          <div>Руководитель охотпользователя</div>
          <div class="mleft-7">
            <p><span>_____________________________</span> <br>подпись</p>
          </div>
          <div class="mleft-7">
            <p><span>_____________________________</span> <br>Ф.И.О.</p>
          </div>
        </div>
      </div>
      <div class="report-footer-item">
        <div class="flexbox">
          <div>М.П.</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    reportData: Object,
    year: String,
    oopt: String,
    mainSoate: String,
    soate: String
  }
}
</script>

<style scoped>

</style>
